module.exports = __webpack_public_path__ + "img/chat-square-dots.be89147b.svg";